import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleAssignCostProfileToResourceRequest(
  resource: Identifiable<Resource>,
  {
    costProfile,
    resource: r,
  }: Boundaries["assignCostProfileToResource"]["request"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? { ...resource, costProfile } : resource;
}

function handleAssignCostProfileToResourceSuccess(
  resource: Identifiable<Resource>,
  {
    costProfile,
    resource: r,
  }: Boundaries["assignCostProfileToResource"]["success"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? { ...resource, costProfile } : resource;
}

function handleAssignCostProfileToResourceFailure(
  resource: Identifiable<Resource>,
  { resource: r }: Boundaries["assignCostProfileToResource"]["failure"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? r : resource;
}

function handleRemoveCostProfileFromResourceRequest(
  resource: Identifiable<Resource>,
  r: Boundaries["removeCostProfileFromResource"]["request"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid
    ? { ...resource, costProfile: null }
    : resource;
}

function handleRemoveCostProfileFromResourceSuccess(
  resource: Identifiable<Resource>,
  r: Boundaries["removeCostProfileFromResource"]["success"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid
    ? { ...resource, costProfile: null }
    : resource;
}

function handleRemoveCostProfileFromResourceFailure(
  resource: Identifiable<Resource>,
  r: Boundaries["removeCostProfileFromResource"]["failure"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? r : resource;
}

export {
  handleAssignCostProfileToResourceRequest,
  handleAssignCostProfileToResourceSuccess,
  handleAssignCostProfileToResourceFailure,
  handleRemoveCostProfileFromResourceRequest,
  handleRemoveCostProfileFromResourceSuccess,
  handleRemoveCostProfileFromResourceFailure,
};
